export const AVAILABLE_LANGUAGES = ['en', 'fr', 'de']